"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withContexts = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var flowRight_1 = tslib_1.__importDefault(require("lodash/flowRight"));
var BackendContext_1 = require("./BackendContext");
var WorkspaceContext_1 = require("./WorkspaceContext");
var wrapDisplayName_1 = require("./wrapDisplayName");
/**
 * Injects backend and workspace provided by BackendProvider & WorkspaceProvider to a component
 * @internal
 */
function withContexts(Chart) {
    return flowRight_1.default(wrapDisplayName_1.wrapDisplayName("withContexts"), BackendContext_1.withBackend, WorkspaceContext_1.withWorkspace)(Chart);
}
exports.withContexts = withContexts;
//# sourceMappingURL=withContexts.js.map